var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observable, BehaviorSubject } from 'rxjs';
import * as esri from 'esri-leaflet';
import { Store } from '@ngrx/store';
import { AppConfigService } from '@app/app-config.service';
import { MapLayerActions } from '@app/modules/gis/actions';
import { getGisToken } from '@app/modules/gis/gis-token';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../app-config.service";
var InterrogatorService = /** @class */ (function () {
    function InterrogatorService(store, appConfigSvc) {
        this.store = store;
        this.appConfigSvc = appConfigSvc;
        this.features = new BehaviorSubject({});
        this.features$ = this.features.asObservable();
        this.layers = [];
        this.basinConfig = {};
        this.playConfig = {};
        this.sourceRockConfig = {};
        this.wellConfig = {};
        this.basinLayerUrl = this.appConfigSvc.getConfig().basinLayerUrl;
        this.playLayerUrl = this.appConfigSvc.getConfig().playLayerUrl;
        this.sourceRockLayerUrl = this.appConfigSvc.getConfig().sourceRockLayerUrl;
        this.wellLayerUrl = this.appConfigSvc.getConfig().wellServiceUrl;
        this.wellServiceUrl = this.appConfigSvc.getConfig().wellServiceUrl;
        this.wellMetadataServiceUrl = this.appConfigSvc.getConfig().wellMetadataServiceUrl;
        this.basinToPlayUrl = this.appConfigSvc.getConfig().basinToPlayUrl;
        this.playMetadataServiceUrl = this.appConfigSvc.getConfig().playMetadataServiceUrl;
        this.wellCoordinatedataServiceUrl = this.appConfigSvc.getConfig().wellCoordinatedataServiceUrl;
        this.sourceRockServiceUrl = this.appConfigSvc.getConfig().sourceRockServiceUrl;
        this.penetrationServiceUrl = this.appConfigSvc.getConfig().penetrationServiceUrl;
        this.wellSourceServiceUrl = this.appConfigSvc.getConfig().wellSourceServiceUrl;
    }
    InterrogatorService.prototype.queryWellsByBasinName = function (url, basinName, attributes, returnGeometry) {
        if (returnGeometry === void 0) { returnGeometry = false; }
        return new Observable(function (observer) {
            getGisToken().then(function (token) {
                var query = esri.query({ url: url, useCors: true, withCredentials: true }).token(token);
                query.where("BASIN_NAME_1 = '" + basinName + "'")
                    .run(function (error, fc) {
                    if (error) {
                        observer.error(error);
                    }
                    else {
                        observer.next(fc);
                        observer.complete();
                    }
                });
            });
        });
    };
    InterrogatorService.prototype.queryPenetrationByBasinName = function (url, basinName, attributes, returnGeometry) {
        if (returnGeometry === void 0) { returnGeometry = false; }
        return new Observable(function (observer) {
            getGisToken().then(function (token) {
                var query = esri.query({ url: url, useCors: true, withCredentials: true }).token(token);
                query.where("BASIN_NAME = '" + basinName + "'").returnGeometry(returnGeometry).fields(attributes)
                    .run(function (error, fc) {
                    if (error) {
                        observer.error(error);
                    }
                    else {
                        observer.next(fc);
                        observer.complete();
                    }
                });
            });
        });
    };
    InterrogatorService.prototype.querywellSourcesByBasinName = function (url, basinName, attributes, returnGeometry) {
        if (returnGeometry === void 0) { returnGeometry = false; }
        return new Observable(function (observer) {
            getGisToken().then(function (token) {
                var query = esri.query({ url: url, useCors: true, withCredentials: true }).token(token);
                query.where("BASIN_NAME = '" + basinName + "'").returnGeometry(returnGeometry).fields(attributes).distinct()
                    .run(function (error, fc) {
                    if (error) {
                        observer.error(error);
                    }
                    else {
                        observer.next(fc);
                        observer.complete();
                    }
                });
            });
        });
    };
    InterrogatorService.prototype.querySourceRockMetadata = function (url, sourceRockMinAge, sourceRockMaxAge, playIDs) {
        var attrs = ['*'];
        var where = "AGE_END = " + sourceRockMinAge + " AND AGE_START = " + sourceRockMaxAge + " AND (" + playIDs.map(function (p) { return "PLAY_ID = '" + p + "'"; }).join(' OR ') + ")";
        return new Observable(function (observer) {
            getGisToken().then(function (token) {
                var query = esri.query({ url: url, useCors: true, withCredentials: true }).token(token);
                query.where(where).returnGeometry(false).fields(attrs)
                    .run(function (error, fc) {
                    if (error) {
                        observer.error(error);
                    }
                    else {
                        observer.next(fc);
                        observer.complete();
                    }
                });
            });
        });
    };
    /* mapping functions */
    InterrogatorService.prototype.SetPlayConfig = function (config) {
        this.store.dispatch(new MapLayerActions.SetMapLoading(true));
        // this.SetFeatures({}, null);
        if (config) {
            this.playConfig = config;
            this.queryFeatures('PLAY', config.featureCollection);
        }
    };
    InterrogatorService.prototype.SetWellConfig = function (config) {
        this.store.dispatch(new MapLayerActions.SetMapLoading(true));
        // this.SetFeatures({}, null);
        if (config) {
            this.wellConfig = config;
            this.queryFeatures('WELL', config.featureCollection);
        }
        this.store.dispatch(new MapLayerActions.SetMapLoading(false));
    };
    InterrogatorService.prototype.SetSourceRockConfig = function (config) {
        this.store.dispatch(new MapLayerActions.SetMapLoading(true));
        this.SetFeatures({}, null, null);
        if (config) {
            this.sourceRockConfig = config;
            this.queryFeatures('SOURCEROCK', config.featureCollection);
        }
    };
    InterrogatorService.prototype.SetBasinConfig = function (config) {
        this.store.dispatch(new MapLayerActions.SetMapLoading(true));
        // this.SetFeatures({}, null);
        if (config) {
            this.basinConfig = config;
            this.queryFeatures('BASIN', config.featureCollection);
        }
    };
    InterrogatorService.prototype.queryFeatures = function (type, features) {
        return __awaiter(this, void 0, void 0, function () {
            var condition, url, token, query;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        switch (type) {
                            case 'PLAY':
                                url = this.playLayerUrl;
                                condition = "" + features.map(function (feature) { return "PLAY_ID = '" + feature.src + "'"; }).join(' OR ');
                                break;
                            case 'SOURCEROCK':
                                url = this.sourceRockLayerUrl;
                                condition = features.map(function (feature) {
                                    return "(AGE_END = " + feature.src.AGE_END + " AND AGE_START = " + feature.src.AGE_START + " AND PLAY_ID = '" + feature.play + "')";
                                })
                                    .join(' OR ');
                                break;
                            case 'BASIN':
                                url = this.appConfigSvc.getConfig().basinLayerUrl;
                                condition = features.map(function (feature) { return "BASIN_NAME = '" + feature.src + "'"; });
                                break;
                            case 'WELL':
                                url = this.wellLayerUrl;
                                condition = features.map(function (feature) { return "BASIN_NAME_1 = '" + feature.basin + "'"; });
                                break;
                            default:
                                url = '';
                                condition = '';
                        }
                        return [4 /*yield*/, getGisToken()];
                    case 1:
                        token = _a.sent();
                        query = esri.query({ url: url, useCors: true, withCredentials: true }).token(token);
                        query.where(condition);
                        query.run(function (error, featureCollection) {
                            if (error) {
                                _this.store.dispatch(new MapLayerActions.SetMapLoading(false));
                            }
                            else {
                                var result = {};
                                if (featureCollection.features.length > 0) {
                                    result = featureCollection.features;
                                }
                                _this.SetFeatures(result, type, _this.layers);
                                if (!Object.keys(result).length) {
                                    _this.store.dispatch(new MapLayerActions.SetMapLoading(false));
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    InterrogatorService.prototype.SetFeatures = function (features, type, layers) {
        this.features.next({ features: features, type: type, layers: layers });
    };
    InterrogatorService.ngInjectableDef = i0.defineInjectable({ factory: function InterrogatorService_Factory() { return new InterrogatorService(i0.inject(i1.Store), i0.inject(i2.AppConfigService)); }, token: InterrogatorService, providedIn: "root" });
    return InterrogatorService;
}());
export { InterrogatorService };
